import { useMutation, useQuery } from "@tanstack/react-query";
import { CommodityType } from "../../models/CommodityType";
import {
  deleteCommodityType,
  getCommodityTypes,
  upsertCommodityType,
} from "../../repositories/CommodityTypesRepository";

// Cache invalidation is handled by SignalR (meta.realtime on the queries).

export const useUpsertCommodityTypeMutation = () => {
  return useMutation({
    mutationFn: async (commodityType: CommodityType) => {
      const resp = await upsertCommodityType(commodityType);
      if (!resp.ok) {
        throw new Error(resp.message);
      }
      const entityId = resp.data.tables[0].rows[0].Id as number;
      return { entityId, resp };
    },
  });
};

export const useDeleteCommodityTypeMutation = () => {
  return useMutation({
    mutationFn: async (commodityTypeId: number) => {
      const resp = await deleteCommodityType(commodityTypeId);
      if (!resp.ok) {
        throw new Error(resp.message);
      }
      return resp;
    },
  });
};

export const useCommodityTypesQuery = (
  onlyActive?: boolean,
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: ["commodity-types", onlyActive],
    meta: { realtime: ["SCRAP.GetCommodityTypes"] },
    queryFn: async ({ signal }) => {
      const resp = await getCommodityTypes(onlyActive, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as CommodityType[];
      }
      throw new Error(resp.message);
    },
    onError,
  });
};
